.au{aspect-ratio:1/1;}